import { render } from "./customers_account_component.vue?vue&type=template&id=45f2e946&scoped=true"
import script from "./customers_account_component.vue?vue&type=script&lang=js"
export * from "./customers_account_component.vue?vue&type=script&lang=js"

import "./customers_account_component.vue?vue&type=style&index=0&id=45f2e946&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f2e946"]])

export default __exports__